import {defineNuxtPlugin, usePluginStoreStore} from '#imports';

export default defineNuxtPlugin(async () => {
  const pluginStoreStore = usePluginStoreStore();
  await pluginStoreStore.getCoreData();
});
